import AsyncLoadable from "../utils/AsyncLoadable";
import requireAuth from "../routes/requireAuth";

const Dashboard = AsyncLoadable(() => import("../pages/dashboard"));
const Contact = AsyncLoadable(() => import("../pages/contact"));
const ViewGroup = AsyncLoadable(() => import("../pages/contact/indexView"));
const AvailableContact = AsyncLoadable(() =>
  import("../pages/contact/AvailContact")
);
const CallerID = AsyncLoadable(() => import("../pages/callerId"));
const Logout = AsyncLoadable(() => import("../pages/Login/logout"));
const UserPersonal = AsyncLoadable(() => import("../pages/userpersonal/index"));
const Companies = AsyncLoadable(() => import("../pages/Companies/index"));
const Tenants = AsyncLoadable(() => import("../pages/Tenants/index"));
const EndUsers = AsyncLoadable(() => import("../pages/EndUsers/index"));
const EditUser= AsyncLoadable(() =>
import("../pages/EndUsers/indexEdit")
);
const Teams = AsyncLoadable(() => import("../pages/Teams/index"));
const Locations = AsyncLoadable(() => import("../pages/Location/index"));
const AddCallerId = AsyncLoadable(() =>
  import("../pages/callerId/addCallerId")
);
const PhoneNumber = AsyncLoadable(() => import("../pages/phoneNumber"));
const BlockPhoneNumber = AsyncLoadable(() =>
  import("../pages/phoneNumber/blocknumber")
);
const SIPDevices = AsyncLoadable(() => import("../pages/SIPDevice"));
const ContactCenter = AsyncLoadable(() => import("../pages/contactCenter"));
const AudioFile = AsyncLoadable(() => import("../pages/Audio"));
const PostAudio = AsyncLoadable(() => import("../pages/Audio/createAudio"));
const EditAudio = AsyncLoadable(() => import("../pages/Audio/editAudio"));
const MusicHold = AsyncLoadable(() => import("../pages/musicHold"));
const VoiceMail = AsyncLoadable(() => import("../pages/voiceMail"));

const EditCenter = AsyncLoadable(() =>
  import("../pages/contactCenter/indexEdit")
);
const CallForwarding = AsyncLoadable(() => import("../pages/callForwarding"));
const CreateCallPro = AsyncLoadable(() =>
  import("../pages/callForwarding/createCallPro")
);
const EditCallPro = AsyncLoadable(() =>
  import("../pages/callForwarding/editCallPro")
);
const UserReports = AsyncLoadable(() =>
  import("../pages/Reporting/userReports")
);
const CallProReports = AsyncLoadable(() =>
  import("../pages/Reporting/callProReport")
);
const CallReports = AsyncLoadable(() =>
  import("../pages/Reporting/contactcenterReport")
);
const AgentReports = AsyncLoadable(() =>
  import("../pages/Reporting/agentReport")
);
const LiveStatus = AsyncLoadable(() =>
  import("../pages/LiveStatus/index")
);
// const CallFlows = AsyncLoadable(() =>
// import("../pages/callFlow/index")
// );
const AudioGroup = AsyncLoadable(() => import("../pages/AudioGroup/index"));
const PostAudioGroup = AsyncLoadable(() =>
  import("../pages/AudioGroup/createAudioGroup")
);
const EditAudioGroup = AsyncLoadable(() =>
  import("../pages/AudioGroup/editAudioGroup")
);

const routes = [
  {
    path: "/dashboard",
    exact: true,
    name: "Index",
    component: requireAuth(Dashboard),
    auth: [1, 2, 3, 4],
  },
  {
    path: "/numbers/default",
    exact: true,
    name: "Phone Number",
    component: requireAuth(PhoneNumber),
    auth: [1, 2, 3],
  },
  {
    path: "/numbers/block",
    exact: true,
    name: "Block Phone Number",
    component: requireAuth(BlockPhoneNumber),
    auth: [3],
  },
  {
    path: "/companies",
    exact: true,
    name: "Companies",
    component: requireAuth(Companies),
    auth: [1],
  },
  {
    path: "/tenants",
    exact: true,
    name: "Tenants",
    component: requireAuth(Tenants),
    auth: [1, 2],
  },
  {
    path: "/endusers",
    exact: true,
    name: "EndUsers",
    component: requireAuth(EndUsers),
    auth: [1, 2, 3],
  },
  {
    path: "/enduser/edit/:id",
    exact: true,
    name: "Edit Contact Center",
    component: requireAuth(EditUser),
    auth: [1, 2, 3],
  },
  {
    path: "/teams",
    exact: true,
    name: "Teams",
    component: requireAuth(Teams),
    auth: [3],
  },
  {
    path: "/location",
    exact: true,
    name: "Location",
    component: requireAuth(Locations),
    auth: [3],
  },
   {
    path: "/user-report",
    exact: true,
    name: "User Reports",
    component: requireAuth(UserReports),
    auth: [1, 2],
  },
  {
    path: "/contact-center-report",
    exact: true,
    name: "Contact Center Reports",
    component: requireAuth(CallReports),
    auth: [1, 2],
  },
  {
    path: "/callpro-report",
    exact: true,
    name: "Call Pro Reports",
    component: requireAuth(CallProReports),
    auth: [1, 2],
  },
  {
    path: "/agent-report",
    exact: true,
    name: "Contact Center Reports",
    component: requireAuth(AgentReports),
    auth: [1, 2],
  },
  {
    path: "/live-status",
    exact: true,
    name: "Live Status",
    component: requireAuth(LiveStatus),
    auth: [1, 2],
  },
  {
    path: "/voice/user-report",
    exact: true,
    name: "User Reports",
    component: requireAuth(UserReports),
    auth: [3],
  },
  {
    path: "/voice/contact-center-report",
    exact: true,
    name: "Contact Center Reports",
    component: requireAuth(CallReports),
    auth: [3],
  },
  {
    path: "/voice/callpro-report",
    exact: true,
    name: "Call Pro Reports",
    component: requireAuth(CallProReports),
    auth: [3],
  },
  {
    path: "/voice/agent-report",
    exact: true,
    name: "Contact Center Reports",
    component: requireAuth(AgentReports),
    auth: [3],
  },
  {
    path: "/voice/live-status",
    exact: true,
    name: "Live Status",
    component: requireAuth(LiveStatus),
    auth: [3],
  },
  {
    path: "/voice/contact-center",
    exact: true,
    name: "Contact Center",
    component: requireAuth(ContactCenter),
    auth: [3, 4],
  },
 
  {
    path: "/voice/contact-center/edit/:id",
    exact: true,
    name: "Edit Contact Center",
    component: requireAuth(EditCenter),
    auth: [3, 4],
  },
  {
    path: "/voice/call-forwarding",
    exact: true,
    name: "Call Forwarding",
    component: requireAuth(CallForwarding),
    auth: [3, 4],
  },
  {
    path: "/voice/call-forwarding/create",
    exact: true,
    name: "Create Contact Center",
    component: requireAuth(CreateCallPro),
    auth: [3, 4],
  },
  {
    path: "/voice/call-forwarding/edit/:id",
    exact: true,
    name: "Edit Contact Center",
    component: requireAuth(EditCallPro),
    auth: [3, 4],
  },
  {
    path: "/voice/sip-device",
    exact: true,
    name: "SIP Devices",
    component: requireAuth(SIPDevices),
    auth: [3, 4],
  },
  {
    path: "/voice/audio-file",
    exact: true,
    name: "Audio File",
    component: requireAuth(AudioFile),
    auth: [3, 4],
  },
  {
    path: "/voice/audio-file/create",
    exact: true,
    name: "Create Audio",
    component: requireAuth(PostAudio),
    auth: [3, 4],
  },
  {
    path: "/voice/audio-file/edit/:id",
    exact: true,
    name: "Edit Audio",
    component: requireAuth(EditAudio),
    auth: [3, 4],
  },
  {
    path: "/voice/audio-group",
    exact: true,
    name: "Audio Grouo",
    component: requireAuth(AudioGroup),
    auth: [3, 4],
  },
  {
    path: "/voice/audio-group/create",
    exact: true,
    name: "Create Audio Group",
    component: requireAuth(PostAudioGroup),
    auth: [3, 4],
  },
  {
    path: "/voice/audio-group/edit/:id",
    exact: true,
    name: "Edit Audio Group",
    component: requireAuth(EditAudioGroup),
    auth: [3, 4],
  },
  {
    path: "/voice/music-on-hold",
    exact: true,
    name: "Music On Hold",
    component: requireAuth(MusicHold),
    auth: [3, 4],
  },
  // {
  //   path: "/voice/voice-mail",
  //   exact: true,
  //   name: "Voice Mail",
  //   component: requireAuth(VoiceMail),
  //   auth: [3, 4],
  // },
  // {
  //   path: "/call_flow/create_call-flow",
  //   exact: true,
  //   name: "Call Flows",
  //   component: requireAuth(CallFlows),
  //   auth: [3, 4],
  // },

  {
    path: "/manage_group/contact",
    exact: true,
    name: "Contact Group",
    component: requireAuth(Contact),
    auth: [3, 4],
  },
  {
    path: "/manage_group/view_group/:id",
    exact: true,
    name: "View Group",
    component: requireAuth(ViewGroup),
    auth: [3, 4],
  },
  {
    path: "/manage_group/view_group/add_contact_group/:id",
    exact: true,
    name: "Contact Group",
    component: requireAuth(AvailableContact),
    auth: [3, 4],
  },
  {
    path: "/manage_group/callerid",
    exact: true,
    name: "CID Group",
    component: requireAuth(CallerID),
    auth: [3, 4],
  },
  {
    path: "/manage_group/callerid/add_callerid",
    exact: true,
    name: "CID Group",
    component: requireAuth(AddCallerId),
    auth: [3, 4],
  },
  {
    path: "/logout",
    exact: true,
    name: "Personal",
    component: Logout,
    auth: [1, 2, 3, 4],
  },
  {
    path: "/personal-setting",
    exact: true,
    name: "Personal",
    component: UserPersonal,
    auth: [1, 2, 3, 4],
  },
];

export default routes;
